/* HyperEcom (Shopify) – landing sections behaviour. Shares markup + CSS with the WordPress Product Landing Builder. */
(function () {
	'use strict';

	function init(root) {
		if (root.dataset.plbReady) return;
		root.dataset.plbReady = '1';
		var q = function (s) { return root.querySelector(s); };
		var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

		/* tracking (Meta / GA4 / GTM via track.js) */
		var tEvt = function (name, b) {
			if (!window.plbTrack || !b) return;
			var v = +b.dataset.value || 0;
			window.plbTrack(name, {
				value: v, currency: root.dataset.currency,
				items: [{ id: (+b.dataset.vid ? b.dataset.vid : root.dataset.pid), name: root.dataset.pname, variant: b.dataset.label, price: v, quantity: 1 }]
			});
		};
		var current = function () { return root.querySelector('.plb-b[aria-checked="true"]') || root.querySelector('.plb-b'); };

		/* sale countdown – counts down to a real deadline (set in the builder or WooCommerce sale end date) */
		var sale = q('.plb-sale');
		if (sale) {
			var end = +sale.dataset.end, cd = sale.querySelector('.js-plb-cd'), after = sale.dataset.after;
			var visitor = sale.dataset.visitor, mins = +sale.dataset.minutes || 30, key = 'plb_cd_' + visitor;
			var store = function (k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } };
			var startNew = function () { end = Date.now() + mins * 60000; store(key, String(end)); };
			if (visitor) {
				// Per-visitor timer: starts on first visit, kept across reloads (or restarted on every load if chosen).
				var saved = +store(key) || 0;
				if (sale.dataset.reset === '1' || !saved || (saved <= Date.now() && after === 'loop')) startNew();
				else end = saved;
			}
			var pad = function (n) { return (n < 10 ? '0' : '') + n; };
			var timer;
			var tick = function () {
				var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
				if (!left && visitor && after === 'loop') { startNew(); left = mins * 60; }
				var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
				cd.textContent = (d ? d + 'd ' : '') + (d || h ? pad(h) + ':' : '') + pad(m) + ':' + pad(s);
				if (!left) {
					clearInterval(timer);
					if (after === 'message') { sale.querySelector('.timer').hidden = true; sale.querySelector('.ended').hidden = false; }
					else sale.hidden = true;
				}
			};
			timer = setInterval(tick, 1000);
			tick();
		}

		/* gallery */
		var main = q('.js-plb-main');
		qa('.js-plb-thumbs button').forEach(function (b) {
			b.addEventListener('click', function () {
				if (main) main.src = b.dataset.full;
				qa('.js-plb-thumbs button').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
			});
		});
		qa('.js-plb-tscroll').forEach(function (a) {
			a.addEventListener('click', function () {
				var t = q('.js-plb-thumbs');
				if (t) t.scrollBy({ left: a.dataset.dir * t.clientWidth * 0.6, behavior: 'smooth' });
			});
		});

		/* bundles */
		var pills = qa('.plb-b'), ssel = q('.js-plb-ssel');
		function select(i) {
			var b = pills[i];
			if (!b) return;
			pills.forEach(function (p, j) { p.setAttribute('aria-checked', j === i ? 'true' : 'false'); p.tabIndex = j === i ? 0 : -1; });
			qa('.js-plb-cart').forEach(function (a) { a.href = b.dataset.cart; });
			qa('input[name="id"]').forEach(function (inp) { inp.value = b.dataset.vid; });
			qa('[data-checkout]').forEach(function (a) { if (a.tagName === 'A') a.href = b.dataset.checkout; });
			qa('.js-plb-sp').forEach(function (e) { e.textContent = b.dataset.price; });
			qa('.js-plb-sw').forEach(function (e) { e.textContent = b.dataset.was || ''; });
			qa('.js-plb-ss').forEach(function (e) { e.textContent = b.dataset.save || ''; e.parentNode.hidden = !b.dataset.save; });
			if (ssel) ssel.value = i;
		}
		pills.forEach(function (p, i) {
			p.addEventListener('click', function () { var was = p.getAttribute('aria-checked') === 'true'; select(i); if (!was) tEvt('select_item', p); });
			p.addEventListener('keydown', function (e) {
				var d = /Down|Right/.test(e.key) ? 1 : /Up|Left/.test(e.key) ? -1 : 0;
				if (!d) return;
				e.preventDefault();
				var n = (i + d + pills.length) % pills.length;
				select(n); pills[n].focus();
			});
		});
		if (ssel && !ssel.options.length) {
			pills.forEach(function (p, i) {
				var o = document.createElement('option');
				o.value = i; o.textContent = (p.dataset.label || '').replace(/[🔥💎⏰]/g, '').trim() + ' – ' + p.dataset.price;
				ssel.appendChild(o);
			});
		}
		if (ssel) ssel.addEventListener('change', function () { select(+ssel.value); });

		/* demo page: buying is switched off – explain instead */
		if (root.hasAttribute('data-demo')) {
			var note;
			root.addEventListener('click', function (e) {
				var t = e.target.closest ? e.target.closest('.js-plb-cart, a[data-checkout], .plb-demo-pay') : null;
				if (!t) return;
				e.preventDefault(); e.stopPropagation();
				if (!note) {
					note = document.createElement('div');
					note.className = 'plb-demo-toast';
					note.setAttribute('role', 'status');
					note.innerHTML = '<b>This is a demo page.</b> Buttons are switched off here. To sell for real: open a product → Theme template → <b>landing</b>, then give it one variant per bundle.';
					root.appendChild(note);
				}
				note.classList.remove('on'); void note.offsetWidth; note.classList.add('on');
				clearTimeout(note._t); note._t = setTimeout(function () { note.classList.remove('on'); }, 5000);
			}, true);
		}
		var def = pills.findIndex(function (p) { return p.getAttribute('aria-checked') === 'true'; });
		select(def < 0 ? 0 : def);

		/* before / after */
		var ba = q('.plb-ba');
		if (ba) {
			var r = ba.querySelector('input'), top = ba.querySelector('.top'), ln = ba.querySelector('.ln');
			r.addEventListener('input', function () { top.style.clipPath = 'inset(0 ' + (100 - r.value) + '% 0 0)'; ln.style.left = r.value + '%'; });
		}

		/* social carousel */
		var track = q('.plb-track');
		qa('.plb-car .nav').forEach(function (n) {
			n.addEventListener('click', function () {
				if (track) track.scrollBy({ left: (n.classList.contains('l') ? -1 : 1) * track.clientWidth / 1.5, behavior: 'smooth' });
			});
		});

		/* reviews */
		var grid = q('.plb-grid');
		if (grid) {
			var cards = qa('.plb-rc'), per = +grid.dataset.per || 8, filter = 'all', shown = per;
			var more = q('.plb-loadmore'), empty = q('.plb-empty'), sort = q('.js-plb-sort');
			var draw = function () {
				var n = 0;
				Array.prototype.slice.call(grid.children).forEach(function (c) {
					var ok = filter === 'all' || (filter === 'photo' && c.dataset.photo === '1') || c.dataset.stars === filter;
					c.hidden = !(ok && n < shown);
					if (ok) n++;
				});
				if (more) more.hidden = n <= shown;
				if (empty) empty.hidden = n > 0;
			};
			qa('.plb-flt button').forEach(function (b) {
				b.addEventListener('click', function () {
					filter = b.dataset.f; shown = per;
					qa('.plb-flt button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
					draw();
				});
			});
			if (sort) sort.addEventListener('change', function () {
				var key = { helpful: function (c) { return -c.dataset.helpful; }, high: function (c) { return -c.dataset.stars; }, low: function (c) { return +c.dataset.stars; } }[sort.value]
					|| function (c) { return +c.dataset.i; };
				cards.slice().sort(function (a, b) { return key(a) - key(b) || a.dataset.i - b.dataset.i; }).forEach(function (c) { grid.appendChild(c); });
				shown = per; draw();
			});
			if (more) more.addEventListener('click', function () { shown += per; draw(); });
			qa('.plb-rc .more').forEach(function (m) {
				m.addEventListener('click', function () {
					var p = m.parentNode;
					p.querySelector('.s').hidden = true;
					p.querySelector('.f').hidden = false;
					m.remove();
				});
			});
			draw();
		}

		/* sticky bar: appears once the main add-to-cart scrolls out of view */
		var sticky = q('.plb-sticky'), mainBtn = q('.plb-buy .js-plb-cart');
		if (sticky && mainBtn) {
			var shown = null, ticking = false;
			var check = function () {
				ticking = false;
				var show = mainBtn.getBoundingClientRect().bottom < 0;
				if (show === shown) return;
				shown = show;
				sticky.classList.toggle('show', show);
				sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
				sticky.querySelectorAll('a,select').forEach(function (el) { el.tabIndex = show ? 0 : -1; });
			};
			var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } };
			window.addEventListener('scroll', onScroll, { passive: true });
			window.addEventListener('resize', onScroll);
			check();
		}

		/* live "orders today" counter – per-visitor start, count-up, then ticks up while they browse */
		var live = q('.plb-live b[data-live]');
		if (live) {
			var ls = function (k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } };
			var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
			var lmin = +live.dataset.min || 0, lmax = +live.dataset.max || 0, isRange = lmax > 0;
			var typed = parseInt(String(live.textContent).replace(/[^0-9]/g, ''), 10) || 0;
			var day = new Date().toDateString(), lkey = 'plb_live_' + (live.dataset.pid || '0');
			var lo = isRange ? lmin : typed;
			var cap = Math.round((isRange ? lmax : typed) * 1.25) + 10;
			var cur = isRange ? lmin + Math.floor(Math.random() * (lmax - lmin + 1)) : typed;
			var prev = null;
			try { prev = JSON.parse(ls(lkey) || 'null'); } catch (e) { prev = null; }
			if (prev && prev.d === day && prev.v >= lo && prev.v <= cap) cur = prev.v; // same visitor, same day: keep their number
			var fmt = function (n) { return n.toLocaleString('en-US'); };
			var keep = function () { ls(lkey, JSON.stringify({ d: day, v: cur })); };
			keep();

			if (reduce) {
				live.textContent = fmt(cur);
			} else {
				var from = Math.floor(cur * 0.55), t0 = 0, dur = 1500;
				var run = function (ts) {
					if (!t0) t0 = ts;
					var k = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - k, 3);
					live.textContent = fmt(Math.round(from + (cur - from) * e));
					if (k < 1) requestAnimationFrame(run);
				};
				var startCount = function () { requestAnimationFrame(run); };
				if ('IntersectionObserver' in window) {
					var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); startCount(); } }, { threshold: 0.4 });
					io.observe(live);
				} else startCount();
			}

			var tick = function () {
				if (!document.hidden && cur < cap) {
					var add = Math.random() < 0.7 ? 1 : (Math.random() < 0.7 ? 2 : 3);
					cur += add;
					live.textContent = fmt(cur);
					keep();
					if (!reduce) {
						live.classList.remove('plb-bump'); void live.offsetWidth; live.classList.add('plb-bump');
						var plus = document.createElement('span');
						plus.className = 'plb-plus'; plus.textContent = '+' + add;
						live.parentNode.appendChild(plus);
						setTimeout(function () { if (plus.parentNode) plus.parentNode.removeChild(plus); }, 1300);
					}
				}
				setTimeout(tick, 7000 + Math.random() * 16000);
			};
			setTimeout(tick, 5000 + Math.random() * 7000);
		}

		/* "Images from reviews" strip arrows */
		var strip = q('.js-plb-strip');
		if (strip) {
			var navs = qa('.js-plb-snav');
			var upd = function () {
				var max = strip.scrollWidth - strip.clientWidth - 2;
				navs.forEach(function (n) { n.hidden = max <= 0 || (n.dataset.dir === '-1' ? strip.scrollLeft <= 2 : strip.scrollLeft >= max); });
			};
			navs.forEach(function (n) {
				n.addEventListener('click', function () { strip.scrollBy({ left: +n.dataset.dir * strip.clientWidth * 0.8, behavior: 'smooth' }); });
			});
			strip.addEventListener('scroll', upd, { passive: true });
			window.addEventListener('resize', upd);
			upd();
		}

		/* photo lightbox (strip + review cards) */
		var lbBox = null, lbList = [], lbI = 0, lbLast = null;
		var lbShow = function () {
			var b = lbList[lbI];
			lbBox.querySelector('img').src = b.dataset.full;
			lbBox.querySelector('.n').textContent = b.dataset.name || '';
			lbBox.querySelector('.s').textContent = b.dataset.stars || '';
			lbBox.querySelector('.t').textContent = b.dataset.text || '';
			lbBox.querySelector('.cap').hidden = !(b.dataset.name || b.dataset.text);
			lbBox.querySelector('.c').textContent = lbList.length > 1 ? (lbI + 1) + ' / ' + lbList.length : '';
			lbBox.querySelectorAll('.pv,.nx').forEach(function (x) { x.hidden = lbList.length < 2; });
		};
		var lbClose = function () { lbBox.hidden = true; document.documentElement.style.overflow = ''; if (lbLast) lbLast.focus(); };
		var lbKey = function (e) {
			if (!lbBox || lbBox.hidden) return;
			if (e.key === 'Escape') lbClose();
			if (e.key === 'ArrowRight') { lbI = (lbI + 1) % lbList.length; lbShow(); }
			if (e.key === 'ArrowLeft') { lbI = (lbI - 1 + lbList.length) % lbList.length; lbShow(); }
		};
		qa('.js-plb-lb').forEach(function (b) {
			b.addEventListener('click', function () {
				if (!lbBox) {
					lbBox = document.createElement('div');
					lbBox.className = 'plb-lb';
					lbBox.setAttribute('role', 'dialog');
					lbBox.setAttribute('aria-modal', 'true');
					lbBox.innerHTML = '<div class="bx"><button type="button" class="x" aria-label="Close">&times;</button><button type="button" class="pv" aria-label="Previous">&#10094;</button><img alt=""><button type="button" class="nx" aria-label="Next">&#10095;</button><div class="cap"><b class="n"></b> <span class="s"></span><p class="t"></p></div><span class="c"></span></div>';
					root.appendChild(lbBox);
					lbBox.addEventListener('click', function (e) { if (e.target === lbBox) lbClose(); });
					lbBox.querySelector('.x').addEventListener('click', lbClose);
					lbBox.querySelector('.pv').addEventListener('click', function () { lbI = (lbI - 1 + lbList.length) % lbList.length; lbShow(); });
					lbBox.querySelector('.nx').addEventListener('click', function () { lbI = (lbI + 1) % lbList.length; lbShow(); });
					document.addEventListener('keydown', lbKey);
				}
				lbList = qa('.js-plb-lb[data-group="' + b.dataset.group + '"]');
				lbI = Math.max(0, lbList.indexOf(b));
				lbLast = b;
				lbShow();
				lbBox.hidden = false;
				document.documentElement.style.overflow = 'hidden';
				lbBox.querySelector('.x').focus();
			});
		});

		/* mobile swipe gallery */
		var mt = q('.js-plb-mtrack');
		if (mt) {
			var dots = qa('.mdots button');
			var idx = function () { return Math.round(mt.scrollLeft / Math.max(1, mt.children[0].offsetWidth + 6)); };
			var go = function (i) { i = Math.max(0, Math.min(mt.children.length - 1, i)); mt.scrollTo({ left: mt.children[i].offsetLeft - mt.offsetLeft, behavior: 'smooth' }); };
			var mark = function () { var i = idx(); dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); }); };
			mt.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true });
			dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.i); }); });
			qa('.js-plb-mnav').forEach(function (b) { b.addEventListener('click', function () { var n = idx() + +b.dataset.dir; if (n >= mt.children.length) n = 0; if (n < 0) n = mt.children.length - 1; go(n); }); });
		}

		/* recent-orders popup (real orders, honest time-ago) */
		var toast = q('.plb-toast');
		if (toast && !sessionStorage.getItem('plb_toast_off')) {
			var list = [];
			try { list = JSON.parse(toast.dataset.orders || '[]'); } catch (e) { list = []; }
			var ago = function (t) {
				var s = Math.max(60, Math.floor(Date.now() / 1000 - t));
				if (s < 3600) return Math.floor(s / 60) + ' min ago';
				if (s < 86400) { var h = Math.floor(s / 3600); return h + (h === 1 ? ' hour ago' : ' hours ago'); }
				var dd = Math.floor(s / 86400); return dd + (dd === 1 ? ' day ago' : ' days ago');
			};
			var ti = 0, stop = false;
			var showOne = function () {
				if (stop || !list.length) return;
				var o = list[ti % list.length]; ti++;
				toast.querySelector('.tx').innerHTML = '';
				var b = document.createElement('b'); b.textContent = o.n + (o.c ? ' from ' + o.c : '');
				var sm = document.createElement('small'); sm.textContent = 'placed an order · ' + ago(o.t);
				toast.querySelector('.tx').appendChild(b); toast.querySelector('.tx').appendChild(sm);
				toast.hidden = false;
				requestAnimationFrame(function () { toast.classList.add('on'); });
				setTimeout(function () { toast.classList.remove('on'); setTimeout(function () { toast.hidden = true; }, 400); }, 5000);
				if (ti < list.length * 2) setTimeout(showOne, 14000 + Math.random() * 12000);
			};
			toast.querySelector('.x').addEventListener('click', function () { stop = true; toast.classList.remove('on'); toast.hidden = true; try { sessionStorage.setItem('plb_toast_off', '1'); } catch (e) {} });
			setTimeout(showOne, 6000 + Math.random() * 4000);
		}

		/* view_item / add_to_cart / checkout are sent by Shopify itself */
		root.addEventListener('click', function (e) {
			if (!e.target.closest) return;
			if (e.target.closest('a[data-checkout]')) tEvt('begin_checkout', current());
		}, true);

		/* Add to cart: Shopify AJAX cart + slide-out cart (falls back to /cart/add) */
		root.addEventListener('click', function (e) {
			var a = e.target.closest ? e.target.closest('.js-plb-cart') : null;
			if (!a || !window.nsCart) return;
			var b = current();
			if (!b || !b.dataset.vid) return;
			e.preventDefault();
			window.nsCart.add(b.dataset.vid, 1, a);
		});
	}

	function boot() { document.querySelectorAll('[data-plb]').forEach(init); }
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
	document.addEventListener('shopify:section:load', boot); // theme editor re-renders sections

	// Elementor editor / popups re-render widgets
	window.addEventListener('elementor/frontend/init', function () {
		if (window.elementorFrontend && elementorFrontend.hooks) {
			elementorFrontend.hooks.addAction('frontend/element_ready/shortcode.default', boot);
		}
	});
})();
